import type { LocaleDictionary } from "@/i18n/types";

const nsAuthEN = {
  login: {
    button: "Log In",
  },
  loginWaiting: {
    message: "Logging in...",
  },
  emailVerification: {
    instruction:
      "A verification email has been sent. Please check your email and log in again.",
    resendSuccess: "Verification email resent. Please verify and log in again.",
    // api-server の detail は日本語のみなので en では文面に含めない
    resendError: (_params: { detail: string }) =>
      "Failed to resend the verification email.",
    resendButton: "Resend",
    reloginButton: "Log In Again",
    logoutButton: "Log Out",
    dismissLabel: "Dismiss",
  },
  initialSetting: {
    pageTitle: "Initial Setup",
    mfa: {
      question:
        "Would you like to set up two-factor authentication to prevent unauthorized logins?",
      note: "You can also set this up later in Account Settings.",
      setupButton: "Set Up Two-Factor Authentication",
      skipButton: "Skip 2FA and Log In",
      inProgressTitle: "Processing",
      errorMessage: "Failed to save the setting",
    },
    organization: {
      checkOrganizationsButton: "View My Organizations",
    },
  },
} satisfies LocaleDictionary;

export default nsAuthEN;
